import PdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?worker'

import type * as pdfjsLib from 'pdfjs-dist'

type Pdfjs = typeof pdfjsLib

let pdfjsLoad: Promise<Pdfjs> | null = null

/**
 * `pdfjs-dist` for the PDF preview, loaded on first use (it is large) with one worker
 * shared by every document.
 *
 * The worker comes in through Vite's `?worker` import rather than
 * `GlobalWorkerOptions.workerSrc`: Vite emits it as a same-origin `.js` chunk, which
 * CSP `worker-src 'self'` allows and every host serves with a JavaScript MIME type.
 * A raw `.mjs` asset URL would depend on the server getting that type right.
 * `@aiden0z/pptx-renderer` runs its own pdfjs inside a private blob worker, so the
 * global port set here does not reach it.
 */
export function loadPdfjs(): Promise<Pdfjs> {
  pdfjsLoad ??= import('pdfjs-dist')
    .then((pdfjs) => {
      pdfjs.GlobalWorkerOptions.workerPort = new PdfjsWorker()
      return pdfjs
    })
    .catch((error: unknown) => {
      // A failed chunk load must not poison every later preview.
      pdfjsLoad = null
      throw error
    })
  return pdfjsLoad
}
